






import { mapState } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: {
    ...mapState(['userAvatar', 'userName']),
  },
})
export default class UserAvatar extends Vue {
  @Prop({
    default: null,
  })
  public avatar!: string;

  public userAvatar!: string;
  public userName!: string;

  public get newUserAvatar(): string {
    if (this.avatar) {
      return this.avatar;
    }

    if (this.userAvatar) {
      return this.userAvatar;
    }

    let name = 'somename';

    if (this.userName) {
      name = this.userName.replace(/[^a-z0-9]+/i, '');
    }

    return `https://avatars.dicebear.com/v2/human/${name}.svg?options[mood][]=happy`;
  }
}
